import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const adminHeaders = () => {
  const p = sessionStorage.getItem("adminPasscode");
  return p ? { "X-Admin-Passcode": p } : {};
};

export const createPurchase = async (payload) => {
  const { data } = await axios.post(`${API}/purchases`, payload);
  return data;
};

export const getPurchase = async (reference) => {
  const { data } = await axios.get(`${API}/purchases/${reference}`);
  return data;
};

export const listPurchases = async () => {
  const { data } = await axios.get(`${API}/purchases`, { headers: adminHeaders() });
  return data;
};

export const markPaid = async (reference, paid) => {
  const { data } = await axios.patch(
    `${API}/purchases/${reference}/paid`,
    { paid },
    { headers: adminHeaders() },
  );
  return data;
};

export const deletePurchase = async (reference) => {
  const { data } = await axios.delete(`${API}/purchases/${reference}`, { headers: adminHeaders() });
  return data;
};

export const deleteAllPurchases = async () => {
  const { data } = await axios.delete(`${API}/purchases`, { headers: adminHeaders() });
  return data;
};

export const verifyAdminPasscode = async (passcode) => {
  const { data } = await axios.post(`${API}/admin/verify`, { passcode });
  return data;
};

export const createCheckoutSession = async (reference) => {
  const { data } = await axios.post(`${API}/purchases/${reference}/create-checkout-session`);
  return data;
};
